import React from 'react';
import AudioGenerationDashboard from '@/components/admin/AudioGenerationDashboard';
import { GenerateMissingAudioButton } from '@/components/admin/GenerateMissingAudioButton';
import { AudioStatusDashboard } from '@/components/admin/AudioStatusDashboard';

// Admin Audio Generation page
// This now uses the unified AudioGenerationDashboard which includes
// the Admin Controls card with the Force Cancel Operation button.

const AudioGenerationPage: React.FC = () => {
  return (
    <div className="container mx-auto p-6 max-w-6xl">
      {/* Audio System Health Dashboard */}
      <AudioStatusDashboard />
      
      <div className="mb-6">
        <GenerateMissingAudioButton />
      </div>
      <AudioGenerationDashboard />
    </div>
  );
};

export default AudioGenerationPage;
